import { render, staticRenderFns } from "./CompletedClasses.vue?vue&type=template&id=0abfe542&scoped=true"
import script from "./CompletedClasses.vue?vue&type=script&lang=js"
export * from "./CompletedClasses.vue?vue&type=script&lang=js"
import style0 from "./CompletedClasses.vue?vue&type=style&index=0&id=0abfe542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfe542",
  null
  
)

export default component.exports